import { useQuery } from "@tanstack/react-query";
import { getAuthenticatedApiClient } from "../../../api/apiClient";

export const warehouseSyncKeys = {
  all: ["warehouseSync"] as const,
  preview: () => [...warehouseSyncKeys.all, "preview"] as const
};

/**
 * Hub values paired with warehouse values for every counterparty that has a catalyst id.
 *
 * No staleTime and no refetchInterval on purpose: the page writes back what it shows, so a cached
 * hub value from ten minutes ago is exactly what must not be applied. The user refreshes when they
 * want fresh data, and the page refetches after applying.
 */
export const useWarehouseSyncPreview = () =>
  useQuery({
    queryKey: warehouseSyncKeys.preview(),
    queryFn: async () => {
      const apiClient = await getAuthenticatedApiClient();
      const response =
        await apiClient.warehouseSyncPreview.warehouseSyncPreview();
      return response.data;
    },
    staleTime: 0,
    // Reading every counterparty blob is not free, so do not re-run it just because the window
    // regained focus.
    refetchOnWindowFocus: false
  });
